export const MODULATORS_APPLIANCES_TABLE_CARD_FRENCH_LOCALE = {
  title: "Appareils associés au modulateur",
  globalSearchPlaceholder: "Rechercher une valeur...",
  empty: "Aucun appareil trouvé...",
  headers: {
    way: "Voie",
    csId: "Cs Id",
    hwId: "Hw Id",
    applianceType: "Type d'appareil",
    localisation: "Localisation",
    actions: "Actions",
  },
  editDialog: {
    title: "Modifier l'appareil",
    applianceType: "Type d'appareil",
    applianceTypePlaceholder: "Sélectionner un type d'appareil",
    localisation: "Localisation",
    save: "Enregistrer",
    cancel: "Annuler",
  },
};
